import Icon from '../../../components/AppIcon';

const SystemStatus = ({ systems }) => {
  const statusConfig = {
    connected: {
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10',
      label: 'Connected'
    },
    warning: {
      icon: 'AlertTriangle',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      label: 'Warning'
    },
    disconnected: {
      icon: 'XCircle',
      color: 'text-error',
      bgColor: 'bg-error/10',
      label: 'Disconnected'
    },
    maintenance: {
      icon: 'Settings',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      label: 'Maintenance'
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      <div className="flex items-center justify-between p-4 border-b border-border">
        <div className="flex items-center gap-2">
          <Icon name="Activity" size={20} className="text-primary" />
          <h3 className="font-semibold text-foreground">System Status</h3>
        </div>
      </div>
      <div className="p-4 space-y-3">
        {systems?.map((system) => {
          const config = statusConfig?.[system?.status];
          return (
            <div key={system?.id} className="flex items-center justify-between p-3 rounded-lg bg-muted/30">
              <div className="flex items-center gap-3">
                <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${config?.bgColor}`}>
                  <Icon name={config?.icon} size={20} className={config?.color} />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground">{system?.name}</p>
                  <p className="text-xs text-muted-foreground">{system?.description}</p>
                </div>
              </div>
              <div className="text-right">
                <span className={`text-xs font-medium ${config?.color}`}>{config?.label}</span>
                {system?.lastSync && (
                  <p className="text-xs text-muted-foreground mt-1">
                    Last sync: {system?.lastSync}
                  </p>
                )}
              </div>
            </div>
          );
        })}
      </div>
      <div className="p-4 border-t border-border bg-muted/30">
        <div className="flex items-center justify-between text-xs">
          <span className="text-muted-foreground">Overall Health</span>
          <div className="flex items-center gap-2">
            <div className="w-24 h-2 bg-muted rounded-full overflow-hidden">
              <div className="h-full bg-success" style={{ width: '85%' }} />
            </div>
            <span className="font-medium text-success">85%</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SystemStatus;